import React, { useContext, useEffect, useState } from 'react';
import { CButton } from '../../../../components/Common';
import { COLORS } from '../../../../constants';
import { useTradeModalStore } from '../../../../hooks/trade/modalStore';
import { useTradeApi } from '../../../../hooks/trade/tradeApi';
import { Button, Col, Input, Popover, Space, message } from 'antd';
import * as S from './styles';
import { Input as InputMobile } from 'antd-mobile';

import { useTranslation } from 'react-i18next';
import { ThemeContext } from '../../../../../theme/ThemeProvider';
import { useTradePosition } from '../../../../hooks/trade/tradePosition';
import { useOrderBook } from '../../../../hooks/trade/orderBook';
import { useExchangeStore } from '../../../../hooks/trade/exchangeStore';
import { useIndexPrice } from '../../../../hooks/trade/indexprice';
import { useLastPrice } from '../../../../hooks/trade/lastprice';
import BigNumber from 'bignumber.js';
import { getBigNumber } from '../../../../../utils/getBigNumber';
import { formatDecimal } from '../../../../../utils/formatDecimal';
import { MView } from '../../../../../styles/mobilePageStyles';
import { Text, View } from '../../../../../styles/reactnative';
import TPSLEDIT from '../TPSLEDIT';
import KrwPrice from '../../../../components/KrwPrice';

import useSound from 'use-sound';
import order from '../../../../../assets/order.mp3';
import { useDisableScroll } from '@utils/useDisableScroll.tsx';
import console from 'node:console';
import { USER_LOG_TYPE, useUserLogger } from '@/app/hooks/userLogger';
import useCloseAllStore from '../closeAllStore';
import CheckBox from '@app/components/CheckBox';
import CBottomSheet from '@app/components/Common/CBottomSheet';

const sleep = (ms: number) => new Promise((res) => setTimeout(res, ms));

type Job = () => Promise<void>;
const _q: Job[] = [];
let _draining = false;

async function _drain() {
  if (_draining) return;
  _draining = true;
  while (_q.length) {
    const job = _q.shift()!;
    try {
      await job();
    } catch (e) {
      console.error('close job failed:', e);
    }
    const jitter = 200 + Math.floor(Math.random() * 200);
    await sleep(jitter);
  }
  _draining = false;
}

function enqueue(job: Job) {
  _q.push(job);
  _drain();
}

const ClosedBy = ({
  item,
  closeAll,
  setCloseAll,
  isMobile = false,
  refresh = false,
  test,
  orderBookValue,
}: any) => {
  const { EPs } = useExchangeStore();
  const [EP, setEP] = useState(
    EPs?.find((item2: any) => +item2.id == +item?.exchange_pairs_id)
  );
  const { data: modalStore, mutate: muatateModalStore } = useTradeModalStore();
  const { mutateUserLog, getOrderLog } = useUserLogger();
  const [orderSound] = useSound(order, { volume: 1 });
  const { setFalseClose } = useCloseAllStore();

  useEffect(() => {
    setEP(EPs?.find((item2: any) => +item2.id == +item?.exchange_pairs_id));
  }, [EPs, item]);

  useEffect(() => {
    console.log(`/trade/order danger ${test}`, item, closeAll);
    if (closeAll) {
      setFalseClose();

      enqueue(async () => await sendOrder('M', true));
    }
  }, [closeAll]);

  const [open, setOpen] = useState(false);
  const [limit_market, setLimitMarket] = React.useState('L');
  const [amount, setAmount] = React.useState<any>();
  const [selectedPercent, setSelectedPercent] = React.useState<number | null>(
    null
  );

  const { getPrice } = useIndexPrice(item?.exchange_pairs_id);
  const { data: lastprice } = useLastPrice(item?.exchange_pairs_id);
  const [closePrice, setClosePrice] = React.useState<any>();

  // 손익금액(pnl) 계산을 위한 상태 추가
  const [calculatedPnl, setCalculatedPnl] = React.useState<any>();

  const [tp, setTp] = React.useState<any>(item?.tpsl?.[0]?.tp || 0);
  const [sl, setSl] = React.useState<any>(item?.tpsl?.[0]?.sl || 0);
  const { createOrder } = useTradeApi(); // ✅ Context 기반 API Hook 사용
  const { mutate: mutateOrderBook } = useOrderBook(item?.exchange_pairs_id);

  const { mutate: mutatePosition } = useTradePosition();

  const {
    textw,
    gray,
    bgColor,
    mobileTradeBorder,
    raise,
    fail,
    borderColor,
    textGrey,
  } = React.useContext(ThemeContext).theme.COLORS;
  const { isDarkMode } = useContext(ThemeContext);

  const { t } = useTranslation();

  const { data: tradeModalStore, mutate: mutateTradeModalStore } =
    useTradeModalStore();

  // main_sub 값 가져오기 - 컴포넌트 레벨에서 정의
  const mainSub = localStorage.getItem('main_sub') || 'M';

  // 현재 가격 가져오기 - 컴포넌트 레벨에서 정의
  const currentPrice = getPrice(item?.exchange_pairs_id);

  // 컴포넌트 마운트 시 초기 amount 설정
  useEffect(() => {
    // 컴포넌트 마운트 시 1회 실행되어 기본 수량 설정
    if (item?.amount && currentPrice && amount === undefined) {
      // amount가 undefined일 때만 초기화
      // 모든 모드에서 동일하게 코인 수량 * 레버리지로 설정
      const coinValue = getBigNumber(item?.amount)
        .multipliedBy(item?.leverage)
        .toNumber();

      setAmount(coinValue);

      // 기본적으로 100% 선택 상태로 설정
      setSelectedPercent(1);
    }
  }, [item?.amount, item?.leverage, currentPrice, mainSub]);

  useEffect(() => {
    if (orderBookValue) {
      setClosePrice(orderBookValue);
    }
  }, [orderBookValue]);

  // 가격 변경 시 Order by Value 모드일 때 USDT 값 업데이트 (이 부분도 일관되게 처리)
  useEffect(() => {
    if (currentPrice && item?.amount && item?.leverage && selectedPercent) {
      // selectedPercent가 있을 때만 업데이트
      // ✅ FIX: DB amount 그대로 전송 (Backend가 leverage 복원)
      // BEFORE: item.amount * leverage * percent (2배 증폭 버그!)
      // AFTER: item.amount * percent (Backend가 toNotionalAmount 처리)
      const coinValue = getBigNumber(item?.amount)
        .multipliedBy(selectedPercent)
        .toNumber();

      // amount 상태 업데이트
      setAmount(coinValue);
    }
  }, [currentPrice, mainSub, item?.amount, item?.leverage, selectedPercent]);

  // 추가: 지정가일 때도 손익금액 계산 업데이트
  useEffect(() => {
    if (closePrice || amount) {
      const usedClosePrice =
        Number(closePrice) || getPrice(item?.exchange_pairs_id) || item?.price;

      // 모든 모드에서 동일한 계산 방식 사용 (Order By Qty 모드 방식으로 통일)
      const usedAmount = amount || item?.amount * item?.leverage;

      if (limit_market === 'L') {
        // 1. 청산하는 부분의 비율 계산
        const totalAmount = item?.orders?.[0]?.amount || item?.amount;
        const closingRatio = getBigNumber(usedAmount)
          .dividedBy(getBigNumber(totalAmount).multipliedBy(item?.leverage))
          .toNumber();

        // 2. 진입 수수료(엔트리 피)는 청산 비율만큼만 차감
        const entryFee = item?.orders?.[0]?.fee_price || 0;
        const closingEntryFee = getBigNumber(entryFee)
          .multipliedBy(closingRatio)
          .toNumber();

        // 3. 청산 수수료 계산 (실제로는 백엔드에서 계산될 것임)
        // 여기서는 진입 수수료와 동일한 비율로 예상
        const estimatedExitFee = closingEntryFee;

        // 4. PnL 계산: (청산가 - 진입가) * 수량 - 청산부분 진입수수료 - 청산수수료
        const pnlValue = getBigNumber(
          item?.long_short === 'L' ? usedClosePrice : item?.price
        )
          .minus(item?.long_short === 'L' ? item?.price : usedClosePrice)
          .multipliedBy(usedAmount)
          // .minus(closingEntryFee)
          // .minus(estimatedExitFee)
          .toNumber();

        setCalculatedPnl(pnlValue);
      } else {
        // 시장가 주문일 때 손익금액 계산
        // 1. 청산하는 부분의 비율 계산
        const totalAmount = item?.orders?.[0]?.amount || item?.amount;
        const closingRatio = getBigNumber(usedAmount)
          .dividedBy(getBigNumber(totalAmount).multipliedBy(item?.leverage))
          .toNumber();

        // 2. 진입 수수료(엔트리 피)는 청산 비율만큼만 차감
        const entryFee = item?.orders?.[0]?.fee_price || 0;
        const closingEntryFee = getBigNumber(entryFee)
          .multipliedBy(closingRatio)
          .toNumber();

        // 3. 청산 수수료 계산 (실제로는 백엔드에서 계산될 것임)
        // 여기서는 진입 수수료와 동일한 비율로 예상
        const estimatedExitFee = closingEntryFee;

        // 4. PnL 계산
        const pnlValue = getBigNumber(
          item?.long_short === 'L'
            ? getPrice(item?.exchange_pairs_id) || item?.price
            : item?.price
        )
          .minus(
            item?.long_short === 'L'
              ? item?.price
              : getPrice(item?.exchange_pairs_id) || item?.price
          )
          .multipliedBy(usedAmount)
          // .minus(closingEntryFee)
          // .minus(estimatedExitFee)
          .toNumber();

        setCalculatedPnl(pnlValue);
      }
    }
  }, [closePrice, amount, limit_market, getPrice, item]);

  const coin = EP?.pairs?.split('/')[0];
  const currency = EP?.pairs?.split('/')[1];
  let pnl = 0;

  if (item?.long_short === 'L') {
    pnl = getBigNumber(lastprice?.[0]?.price)
      .minus(item?.price)
      .multipliedBy(item?.amount)
      .multipliedBy(item?.leverage)
      .toNumber();
  } else {
    pnl = getBigNumber(item?.price)
      .minus(lastprice?.[0]?.price)
      .multipliedBy(item?.amount)
      .multipliedBy(item?.leverage)
      .toNumber();
  }

  const sendOrder = async (limitmarket, forceAll = false) => {
    try {
      // 컴포넌트 레벨에서 정의된 currentPrice 사용

      // 수량 계산 로직
      let checkamount;

      // main_sub은 항상 'M'으로 설정 (코인 수량 기준)
      // 백엔드에서는 main_sub='M'일 때 amount를 코인 수량으로 해석합니다
      const orderMainSub = 'M'; // 항상 코인 수량 기준으로 주문

      if (forceAll) {
        // closeAll 버튼으로 전체 포지션 청산 시 - 원래 코인 수량 그대로 사용
        checkamount = item?.amount;
      } else {
        // 일반적인 경우(부분 청산)
        if (mainSub === 'S') {
          // UI에서 USDT 가치 모드로 표시하지만, 실제 주문은 코인 수량으로 전송
          if (amount && selectedPercent) {
            // 선택된 퍼센트가 있는 경우 - 코인 수량에 퍼센트 적용
            checkamount = getBigNumber(item?.amount).multipliedBy(
              selectedPercent
            );
            // .toFixed(4);
          } else if (amount) {
            // 사용자가 직접 입력한 경우 - USDT 값을 코인 비율로 변환
            // 전체 USDT 가치 계산
            const totalUsdtValue = getBigNumber(item?.amount)
              .multipliedBy(currentPrice)
              .multipliedBy(item?.leverage);

            // 입력된 USDT 값이 차지하는 비율 계산
            const ratio = getBigNumber(amount).dividedBy(totalUsdtValue);

            // 비율에 따른 코인 수량 계산
            checkamount = getBigNumber(item?.amount).multipliedBy(ratio);
            // .toFixed(4);

            // 최소 1%는 사용하도록 보장
            const minAmount = getBigNumber(item?.amount)
              .multipliedBy(0.01)
              .toFixed(4);
            if (getBigNumber(checkamount).isLessThan(minAmount)) {
              checkamount = minAmount;
            }
          } else {
            // amount가 없는 경우(기본값) - 전체 포지션 청산
            checkamount = item?.amount;
          }
        } else {
          // 수량 기준 설정일 때(mainSub === 'M')
          if (amount && selectedPercent) {
            // 퍼센트 버튼을 클릭한 경우 - amount는 이미 코인 수량 * 레버리지 * 퍼센트로 계산됨
            // 백엔드로 보낼 때는 코인 수량으로 변환해야 함 (레버리지 고려하지 않아야 함)
            checkamount = getBigNumber(item?.amount).multipliedBy(
              selectedPercent
            );
            // .toFixed(4);
          } else if (amount) {
            // 사용자가 직접 입력한 경우 (amount는 코인 수량 * 레버리지로 표시됨)
            // 레버리지로 나누어 실제 코인 수량 계산
            checkamount = getBigNumber(amount).dividedBy(item?.leverage);
            // .toFixed(4);

            // 입력된 양이 전체 포지션보다 크면 전체 포지션으로 제한
            if (getBigNumber(checkamount).isGreaterThan(item?.amount)) {
              checkamount = Number(item?.amount);
              // .toFixed(4);
            }
          } else {
            // amount가 없는 경우(기본값) - 전체 포지션 청산
            checkamount = item?.amount;
          }
        }
      }

      // 최소 주문량 확인 (0보다 커야 함)
      // if (getBigNumber(checkamount).isLessThanOrEqualTo(0)) {
      //   message.error(t('invalidOrderAmount'));
      //   return;
      // }

      // 주문 수량이 너무 작은지 확인 (최소 포지션의 1%)
      const minOrderAmount = getBigNumber(item?.amount)
        .multipliedBy(0.01)
        .toFixed(4);
      if (getBigNumber(checkamount).isLessThan(minOrderAmount)) {
        message.error(t('minimumOrderAmountRequired'));
        return;
      }

      // 불리한 가격인 경우 시장가로 전환하는 로직 추가
      // 지정가 주문 여부 확인
      const isLimitOrder = limitmarket === 'L';

      // 최종 주문 타입 결정
      let finalOrderType = limitmarket;

      if (isLimitOrder) {
        // 주문 가격과 현재 가격 비교
        const orderPrice = Number(closePrice || item?.price);
        const currentMarketPrice = Number(getPrice(item?.exchange_pairs_id));

        // 불리한 가격인지 확인 (청산은 포지션의 반대 방향이므로 조건이 반대)
        const isPriceUnfavorable =
          (item?.long_short === 'L' && orderPrice < currentMarketPrice) || // 롱 포지션 청산인데 지정가가 시장가보다 낮음
          (item?.long_short === 'S' && orderPrice > currentMarketPrice); // 숏 포지션 청산인데 지정가가 시장가보다 높음

        // 불리한 가격이면 시장가로 전환
        if (isPriceUnfavorable) {
          finalOrderType = 'M';
          // message.warning('불리한 가격으로 시장가 전환됨');
        }
      }

      let usePrice = Number(closePrice);
      if (!usePrice) {
        usePrice = item?.price;
      }

      // 나머지 로직은 동일하게 유지...
      const orderParams = {
        ep_id: item?.exchange_pairs_id,
        main_sub: orderMainSub, // 항상 M으로 설정 (코인 수량 기준)
        long_short: item?.long_short === 'L' ? 'S' : 'L',
        cross_iso: item?.cross_iso,
        leverage: item?.leverage,
        position_id: item?.id,
        reduce_position: 1,
        post_only: 1,
        limit_market: finalOrderType,
        price: usePrice,
        amount: checkamount,
      };

      const result = await createOrder(orderParams); // ✅ Demo/Real 자동 선택

      console.log('/trade/order 10');

      if (!modalStore?.sound) {
        orderSound();
      }

      if (result?.result?.success) {
        if (forceAll) {
          mutateUserLog({
            log: USER_LOG_TYPE.ORDER_CLOSE_ALL,
            data: orderParams,
          });
        } else {
          mutateUserLog({
            log: getOrderLog(orderParams, USER_LOG_TYPE.ORDER_CLOSE),
            data: orderParams,
          });
        }
        setTimeout(() => {
          mutateOrderBook();
          mutatePosition();
        }, 500);
        message.success(`${t('positionClosedSuccessfully')}`);
      } else {
        if (result?.result?.message) {
          message.error(`${t(result?.result?.message)}`);
        }
      }
    } catch (error) {
      console.error('Order error:', error);
      message.error(t('orderError'));
    }
  };

  useDisableScroll(open);

  const handleTouchMove = (e) => {
    e.stopPropagation();
  };

  // useEffect(() => {
  //   console.log('amount', amount, selectedPercent);
  // }, [amount]);

  // useEffect(() => {
  //   console.log('item', item);
  // }, [item]);

  // 수정: 문자열을 숫자로 변환하고 설정하는 함수 추가
  const handlePriceChange = (e) => {
    // 입력값을 문자열로 저장 (소수점 입력 중 0이 사라지지 않도록)
    const value = e.target.value;
    setClosePrice(value === '' ? null : value);

    // 지정가 주문일 때 가격 변경시 손익금액 계산
    if (value !== '' && limit_market === 'L') {
      const usedPrice = Number(value);
      const usedAmount = amount || item?.amount * item?.leverage;

      const pnlValue = getBigNumber(
        item?.long_short === 'L' ? usedPrice : item?.price
      )
        .minus(item?.long_short === 'L' ? item?.price : usedPrice)
        .multipliedBy(usedAmount)
        // .minus(item?.orders?.[0]?.fee_price || 0)
        // .minus(getBigNumber(item?.orders?.[0]?.fee_price || 0)
        //   .multipliedBy(item?.orders?.[0]?.amount ?
        //     getBigNumber(item.amount).dividedBy(item.orders[0].amount).toNumber() : 1).toNumber())
        .toNumber();

      setCalculatedPnl(pnlValue);
    }
  };

  // 수정: Enter 키 누르면 페이지 이동 방지
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  // Input 컴포넌트의 onChange 핸들러 수정
  const handleAmountChange = (e) => {
    const value = e.target.value;

    if (value === '') {
      setAmount(''); // 빈 문자열로 설정
      setSelectedPercent(null); // 퍼센트 선택 초기화
    } else {
      setAmount(value);
      setSelectedPercent(null); // 사용자가 직접 입력할 경우 선택된 퍼센트 초기화
    }
  };

  return (
    <View>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          borderRadius: 0,
          backgroundColor: 'transparent',
          display: 'auto',
          padding: 0,
          width: '100%',
          maxWidth: '100%',
        }}
      >
        {/* 모바일: CBottomSheet, 데스크톱: Modal */}
        {isMobile ? (
          <CBottomSheet
            isOpen={open}
            onClose={() => setOpen(false)}
            height="auto"
          >
            <S.BottomSheetHeader>
              <S.BottomSheetTitle>{t('ordercheck')}</S.BottomSheetTitle>
            </S.BottomSheetHeader>
            <S.BottomSheetBody>
              <div onTouchMove={handleTouchMove}>
                {/* 코인 정보 요약 영역 */}
                <S.SummaryBox>
                  <S.SummaryText>{EP?.pairs?.replace('/', '')}</S.SummaryText>
                  <S.Dot />
                  <S.SummaryText>{item?.leverage}x</S.SummaryText>
                  <S.Dot />
                  <S.SummaryText
                    style={{ color: item?.long_short === 'S' ? raise : fail }}
                  >
                    {limit_market === 'M' ? t('market') : t('limit')}{' '}
                    {t(item?.long_short === 'S' ? 'buy' : 'sell')}
                  </S.SummaryText>
                </S.SummaryBox>

                {/* 상세 정보 목록 */}
                <S.InfoList>
                  {/* 주문 유형 */}
                  <S.InfoRow>
                    <S.Label>{t('orderType')}</S.Label>
                    <S.Value>
                      {limit_market === 'M' ? t('market') : t('limit')}
                    </S.Value>
                  </S.InfoRow>

                  {/* 주문 가격 */}
                  <S.InfoRow>
                    <S.Label>{t('price')}</S.Label>
                    <S.Value>
                      {limit_market === 'M'
                        ? `${formatDecimal(getPrice(item?.exchange_pairs_id), EP?.dp || 2)} ${currency}`
                        : closePrice !== null && closePrice !== undefined
                          ? `${formatDecimal(closePrice, EP?.dp || 2)} ${currency}`
                          : `${formatDecimal(item?.price, EP?.dp || 2)} ${currency}`}
                    </S.Value>
                  </S.InfoRow>

                  {/* 수량 */}
                  <S.InfoRow>
                    <S.Label>
                      {mainSub === 'S' ? t('value') : t('quantity')}
                    </S.Label>
                    <S.Value>
                      {formatDecimal(amount || item?.amount, 4)} {coin}
                    </S.Value>
                  </S.InfoRow>

                  {/* 마진 모드 */}
                  <S.InfoRow>
                    <S.Label>{t('marginMode')}</S.Label>
                    <S.Value>
                      {t(item?.cross_iso === 'C' ? 'cross' : 'iso')}
                    </S.Value>
                  </S.InfoRow>

                  {/* 손익 금액 */}
                  <S.InfoRow>
                    <S.Label>{t('pnl')}</S.Label>
                    <S.Value
                      style={{
                        color:
                          calculatedPnl !== undefined
                            ? calculatedPnl > 0
                              ? raise
                              : calculatedPnl < 0
                                ? fail
                                : '#ffffff'
                            : '#ffffff',
                      }}
                    >
                      {(() => {
                        if (calculatedPnl !== undefined) {
                          return `${formatDecimal(calculatedPnl, 4)} ${currency}`;
                        }

                        const usedPrice =
                          limit_market === 'M'
                            ? (getPrice(item?.exchange_pairs_id) ?? item?.price)
                            : (Number(closePrice) ?? item?.price);
                        const entryPrice = item?.price;
                        const usedAmount =
                          amount ?? item?.amount * item?.leverage;
                        const isLong = item?.long_short === 'L';

                        const pnlValue = getBigNumber(
                          isLong ? usedPrice : entryPrice
                        )
                          .minus(isLong ? entryPrice : usedPrice)
                          .multipliedBy(usedAmount)
                          .toNumber();

                        return `${formatDecimal(pnlValue, 4)} ${currency}`;
                      })()}
                    </S.Value>
                  </S.InfoRow>

                  {/* 포지션 감소 */}
                  <S.InfoRow>
                    <S.Label>{t('reduceposition')}</S.Label>
                    <S.Value style={{ color: raise }}>{t('yes')}</S.Value>
                  </S.InfoRow>
                </S.InfoList>

                {/* 다시 보지 않기 체크박스 */}
                <S.CheckboxWrapper>
                  <CheckBox
                    checked={tradeModalStore?.skip}
                    setChecked={(checked) => {
                      mutateTradeModalStore({
                        ...tradeModalStore,
                        skip: checked,
                      });
                    }}
                  />
                  <S.CheckboxLabel style={{ color: textw }}>
                    {t('notagain')}
                  </S.CheckboxLabel>
                </S.CheckboxWrapper>

                {/* 버튼 영역 */}
                <S.ButtonContainer>
                  <S.CancelButton onClick={() => setOpen(false)}>
                    {t('cancel')}
                  </S.CancelButton>
                  <S.ConfirmButton
                    $bgColor={item?.long_short === 'S' ? raise : fail}
                    onClick={() => {
                      sendOrder(limit_market);
                      setOpen(false);
                    }}
                  >
                    {t('confirm')}
                  </S.ConfirmButton>
                </S.ButtonContainer>
              </div>
            </S.BottomSheetBody>
          </CBottomSheet>
        ) : (
          <S.CustomModal
            className={'custom-modal check-position-modal'}
            open={open}
            title={t('ordercheck') + ''}
            onCancel={() => setOpen(false)}
            footer={null}
            centered
            styles={{
              header: {
                marginBottom: '16px',
              },
              body: {
                padding: '0',
              },
            }}
          >
            <div onTouchMove={handleTouchMove}>
              {/* 코인 정보 요약 영역 */}
              <S.SummaryBox>
                <S.SummaryText>{EP?.pairs?.replace('/', '')}</S.SummaryText>
                <S.Dot />
                <S.SummaryText>{item?.leverage}x</S.SummaryText>
                <S.Dot />
                <S.SummaryText
                  style={{ color: item?.long_short === 'S' ? raise : fail }}
                >
                  {limit_market === 'M' ? t('TradePage.Market') : t('TradePage.Limit')}{' '}
                  {t(item?.long_short === 'S' ? 'buy' : 'sell')}
                </S.SummaryText>
              </S.SummaryBox>

              {/* 상세 정보 목록 */}
              <S.InfoList>
                {/* 주문 유형 */}
                <S.InfoRow>
                  <S.Label>{t('orderType')}</S.Label>
                  <S.Value>
                    {limit_market === 'M' ? t('TradePage.Market') : t('TradePage.Limit')}
                  </S.Value>
                </S.InfoRow>

                {/* 주문 가격 */}
                <S.InfoRow>
                  <S.Label>{t('price')}</S.Label>
                  <S.Value>
                    {limit_market === 'M'
                      ? `${formatDecimal(getPrice(item?.exchange_pairs_id), EP?.dp || 2)} ${currency}`
                      : closePrice !== null && closePrice !== undefined
                        ? `${formatDecimal(closePrice, EP?.dp || 2)} ${currency}`
                        : `${formatDecimal(item?.price, EP?.dp || 2)} ${currency}`}
                  </S.Value>
                </S.InfoRow>

                {/* 수량 */}
                <S.InfoRow>
                  <S.Label>
                    {mainSub === 'S' ? t('value') : t('quantity')}
                  </S.Label>
                  <S.Value>
                    {formatDecimal(amount || item?.amount, 4)} {coin}
                  </S.Value>
                </S.InfoRow>

                {/* 마진 모드 */}
                <S.InfoRow>
                  <S.Label>{t('marginMode')}</S.Label>
                  <S.Value>
                    {t(item?.cross_iso === 'C' ? 'cross' : 'iso')}
                  </S.Value>
                </S.InfoRow>

                {/* 손익 금액 */}
                <S.InfoRow>
                  <S.Label>{t('pnl')}</S.Label>
                  <S.Value
                    style={{
                      color:
                        calculatedPnl !== undefined
                          ? calculatedPnl > 0
                            ? raise
                            : calculatedPnl < 0
                              ? fail
                              : '#ffffff'
                          : '#ffffff',
                    }}
                  >
                    {(() => {
                      if (calculatedPnl !== undefined) {
                        return `${formatDecimal(calculatedPnl, 4)} ${currency}`;
                      }

                      const usedPrice =
                        limit_market === 'M'
                          ? (getPrice(item?.exchange_pairs_id) ?? item?.price)
                          : (Number(closePrice) ?? item?.price);
                      const entryPrice = item?.price;
                      const usedAmount =
                        amount ?? item?.amount * item?.leverage;
                      const isLong = item?.long_short === 'L';

                      const pnlValue = getBigNumber(
                        isLong ? usedPrice : entryPrice
                      )
                        .minus(isLong ? entryPrice : usedPrice)
                        .multipliedBy(usedAmount)
                        .toNumber();

                      return `${formatDecimal(pnlValue, 4)} ${currency}`;
                    })()}
                  </S.Value>
                </S.InfoRow>

                {/* 포지션 감소 */}
                <S.InfoRow>
                  <S.Label>{t('reduceposition')}</S.Label>
                  <S.Value style={{ color: raise }}>{t('yes')}</S.Value>
                </S.InfoRow>
              </S.InfoList>

              {/* 다시 보지 않기 체크박스 */}
              <S.CheckboxWrapper>
                <CheckBox
                  checked={tradeModalStore?.skip}
                  setChecked={(checked) => {
                    mutateTradeModalStore({
                      ...tradeModalStore,
                      skip: checked,
                    });
                  }}
                />
                <S.CheckboxLabel style={{ color: textw }}>
                  {t('notagain')}
                </S.CheckboxLabel>
              </S.CheckboxWrapper>

              {/* 버튼 영역 */}
              <S.ButtonContainer>
                <S.CancelButton onClick={() => setOpen(false)}>
                  {t('cancel')}
                </S.CancelButton>
                <S.ConfirmButton
                  $bgColor={item?.long_short === 'S' ? raise : fail}
                  onClick={() => {
                    sendOrder(limit_market);
                    setOpen(false);
                  }}
                >
                  {t('confirm')}
                </S.ConfirmButton>
              </S.ButtonContainer>
            </div>
          </S.CustomModal>
        )}
        {/* 테이블 셀 UI - 모바일/데스크톱 동일 */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 10,
            alignItems: 'flex-end',
          }}
        >
          <div
            style={{
              display: 'flex',
              gap: '4px',
            }}
          >
            <S.LimitMarketButton
              size={'small'}
              onClick={() => {
                if (tradeModalStore?.skip) {
                  sendOrder('M');
                } else {
                  setLimitMarket('M');
                  setOpen(true);
                }
              }}
            >
              {t('TradePage.Market')}
            </S.LimitMarketButton>

            <S.LimitMarketButton
              size={'small'}
              onClick={() => {
                if (tradeModalStore?.skip) {
                  sendOrder('L');
                } else {
                  setLimitMarket('L');
                  setOpen(true);
                }
              }}
            >
              {t('TradePage.Limit')}
            </S.LimitMarketButton>
          </div>

          <Col>
            {/* <div style={{ fontSize: 11, textAlign: 'center' }}>
                    {t('LiquidationPrice')}
                  </div> */}
            <Input
              defaultValue={
                closePrice !== null && closePrice !== undefined
                  ? Number(closePrice).toFixed(EP?.dp || 3)
                  : Number(
                      getPrice(item?.exchange_pairs_id) || item?.price
                    ).toFixed(EP?.dp || 3)
              }
              value={closePrice}
              type="number"
              style={{
                width: 100,
                fontSize: '12px',
                border: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.15)'}`,
                borderRadius: 4,
                backgroundColor: isDarkMode
                  ? 'rgba(255,255,255,0.05)'
                  : 'rgba(0,0,0,0.02)',
                color: textw,
                height: 24,
              }}
              placeholder={t('price')}
              onChange={handlePriceChange}
              onKeyDown={handleKeyDown}
              size={'small'}
              step={parseFloat('0.' + '1'.padStart(EP?.dp || 3, '0'))}
            />
          </Col>

          <Col>
            {/* <div style={{ fontSize: 11, textAlign: 'center' }}>
                    {mainSub === 'S' ? 'Value' : 'Quantity'}
                    {t('quantity')}
                  </div> */}
            <Popover
              content={
                <Space.Compact size="small">
                  <Button
                    size="small"
                    onClick={() => {
                      if (mainSub === 'S') {
                        // Order by Value: 코인 수량으로 계산하도록 수정
                        setAmount(
                          getBigNumber(item?.amount)
                            .multipliedBy(item?.leverage)
                            .multipliedBy(0.25)
                            .toFixed(4)
                        );
                        setSelectedPercent(0.25);
                      } else {
                        // Order by Quantity: 기존 방식 유지
                        setAmount(
                          getBigNumber(item?.amount)
                            .multipliedBy(0.25)
                            .multipliedBy(item?.leverage)
                            .toFixed(4)
                        );
                        setSelectedPercent(0.25);
                      }
                    }}
                  >
                    25%
                  </Button>
                  <Button
                    size="small"
                    onClick={() => {
                      if (mainSub === 'S') {
                        // Order by Value: 코인 수량으로 계산하도록 수정
                        setAmount(
                          getBigNumber(item?.amount)
                            .multipliedBy(item?.leverage)
                            .multipliedBy(0.5)
                            .toFixed(4)
                        );
                        setSelectedPercent(0.5);
                      } else {
                        // Order by Quantity: 기존 방식 유지
                        setAmount(
                          getBigNumber(item?.amount)
                            .multipliedBy(0.5)
                            .multipliedBy(item?.leverage)
                            .toFixed(4)
                        );
                        setSelectedPercent(0.5);
                      }
                    }}
                  >
                    50%
                  </Button>
                  <Button
                    size="small"
                    onClick={() => {
                      if (mainSub === 'S') {
                        // Order by Value: 코인 수량으로 계산하도록 수정
                        setAmount(
                          getBigNumber(item?.amount)
                            .multipliedBy(item?.leverage)
                            .multipliedBy(0.75)
                            .toFixed(4)
                        );
                        setSelectedPercent(0.75);
                      } else {
                        // Order by Quantity: 기존 방식 유지
                        setAmount(
                          getBigNumber(item?.amount)
                            .multipliedBy(0.75)
                            .multipliedBy(item?.leverage)
                            .toFixed(4)
                        );
                        setSelectedPercent(0.75);
                      }
                    }}
                  >
                    75%
                  </Button>
                  <Button
                    size="small"
                    onClick={() => {
                      if (mainSub === 'S') {
                        // Order by Value: 코인 수량으로 계산하도록 수정
                        setAmount(
                          getBigNumber(item?.amount)
                            .multipliedBy(item?.leverage)
                            .toFixed(4)
                        );
                        setSelectedPercent(1);
                      } else {
                        // Order by Quantity: 기존 방식 유지
                        setAmount(
                          getBigNumber(item?.amount)
                            .multipliedBy(item?.leverage)
                            .toFixed(4)
                        );
                        setSelectedPercent(1);
                      }
                    }}
                  >
                    100%
                  </Button>
                </Space.Compact>
              }
              title=""
              trigger="click"
            >
              <Input
                defaultValue={
                  amount
                    ? Number(amount).toFixed(4)
                    : Number(item?.amount).toFixed(4)
                }
                value={amount}
                type="number"
                step={0.001}
                style={{
                  width: 100,
                  fontSize: '12px',
                  border: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.15)'}`,
                  borderRadius: 4,
                  backgroundColor: isDarkMode
                    ? 'rgba(255,255,255,0.05)'
                    : 'rgba(0,0,0,0.02)',
                  color: textw,
                  height: 24,
                }}
                placeholder={t('quantity')}
                onChange={handleAmountChange}
                size={'small'}
              />
            </Popover>
          </Col>
        </div>
        <MView
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            flex: 1,
            width: '100%',
            whiteSpace: 'nowrap',
            marginLeft: 10,
            backgroundColor: 'transparent',
          }}
        >
          {/* TP/SL 정보 - 모바일/데스크톱 동일 */}
          {item?.tpsl?.[0]?.posId && (
            <View
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                fontSize: 10,
                marginRight: 10,
              }}
            >
              <Text
                style={{
                  fontSize: 12,
                  color: '#B3B5BD',
                  fontFamily: 'NanumSquareRound, sans-serif',
                }}
              >
                TP:{' '}
                {item?.tpsl?.[0]?.tp
                  ? parseFloat(item?.tpsl?.[0]?.tp).toString()
                  : '-'}
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  color: '#B3B5BD',
                  fontFamily: 'NanumSquareRound, sans-serif',
                }}
              >
                SL:{' '}
                {item?.tpsl?.[0]?.sl
                  ? parseFloat(item?.tpsl?.[0]?.sl).toString()
                  : '-'}
              </Text>
            </View>
          )}
        </MView>
      </View>
    </View>
  );
};

export default ClosedBy;
